'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dekuRedux = require('@viskan/deku-redux');

var _components = require('./components');

var _components2 = _interopRequireDefault(_components);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBuyableStatus = function getBuyableStatus(props, customer) {
	if (!props.buyable) {
		return false;
	}

	if (props.buyableLoggedIn && customer.logged_in_level !== 2) {
		return false;
	}

	return true;
};

var component = (0, _dekuRedux.connectWrap)(function (_ref, props) {
	var article = _ref.article,
	    breakpoint = _ref.breakpoint,
	    customer = _ref.customer;
	return {
		breakpoint: breakpoint,
		reduxArticle: article.article,
		isBuyable: getBuyableStatus(props, customer)
	};
}, function () {
	return {
		shopcartAdd: _actions.shopcartAdd
	};
})(_components2.default);

exports.default = { component: component, config: _config2.default };